export const isOffline = () => {
  return !navigator.onLine;
};
